import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import theme from '../../theme';

import DeviceIcon from '../../assets/deviceSVG';
import Card from '../../components/Card/Card';
import CardTextElement from '../../components/Card/CardText';
import {t} from 'i18next'

export default class DeviceCard extends PureComponent {
    static propTypes = {
      device: PropTypes.shape({}),
      onSelect: PropTypes.func.isRequired,
    }

    static defaultProps = {
      device: {},
    }

  // @TODO (device.messages && device.messages.current) ? theme.palette.custom.warning : '#2D727F'
  render() {
    const { device } = this.props;
    var color = theme.palette.primary.dark;

    if(this.props.isSelected) {
        color = theme.palette.custom.activeCard
    }

    if(this.props.active) {
        color = theme.palette.custom.activeCard
    }

    if(this.props.sidebarOpen && this.props.active && !this.props.isSelected) {
        color = "#949494";
    }

    if(!this.props.isSelected && this.props.sidebarOpen && !this.props.active) {
        color = "#949494";
    }


    return (
      <Card
        key={device.id}
        label={(device.label.length < 20) ?
          (device.label || '') : 
          (device.label.substr(0, 17) + "\u2026")
        }
        icon={<DeviceIcon width={80} height={80} />}
        handleCardState={() => this.props.onSelect(device.id)}
        color={color}
        >
        <CardTextElement label={[t('DeviceCard.label_id')]} content={[device.deviceid.split("_")[1]]} />
          {device.updateNeeded ? <CardTextElement label={[t('DeviceCard.label_state')]} content={[t('DeviceCard.content_update')]} /> : <CardTextElement label={[t('DeviceCard.label_state')]} content={[(device.online) ? t('DeviceCard.content_state_online') : t('DeviceCard.content_state_offline')]} />}

      </Card>
    );
  }
}
